<template>
    <div class="home">
        <div class="contenbox">
            <div class="mkbox lc">
                <div class="flexbox fle-sb">
                    <div class="boxtit">
                        <i class="el-icon-s-finance fonts4"></i>
                        {{$t('index.manageMoney')}}
                    </div>
                    <div class="btnn" @click="jumptolc">
                        <i class="el-icon-circle-plus"></i>{{$t('index.more')}}
                    </div>
                </div>
                <div :class="['flexbox', 'scro', 'fle-sb',!isApp?'fle-wrap fle-satr margint':'']">
                    <div class="itembox" @click="jumptolcdetail(item.id)" v-for="(item, index) in productList" :key="index+'box'">
                        <div class="flexbox">
                            <img :src="item.image">
                            <div class="imgti">
                                <div class="fonwbig">{{item.name}}</div>
                                <div>{{item.days}}{{$t('index.day')}}</div>
                            </div>
                        </div>
                        <div class="fontappvalue">{{item.rate}}%</div>
                        <div>{{$t('index.unit')}}</div>
                    </div>
                </div>
            </div>
            <div class="mkbox hq">
                <div class="flexbox fle-sb">
                    <div class="boxtit">
                        <i class="el-icon-s-marketing fonts4"></i>
                        {{$t('index.hq')}}
                    </div>
                </div>
                <div :class="['flexbox', 'fle-sb',!isApp?'fle-wrap fle-satr margint2':'']">
                    <div class="itembox hqitem"  v-for="(item, index) in currencyList" :key="index+'box'">
                        <div class="flexbox titbar">
                            <img :src="item.image">
                            <div class="fonwbig">{{item.name}}</div>
                        </div>
                        <div class="flexbox hqbox">
                            <img :src="item.image">
                            <div class="hqbox">
                                <div class="colory">${{item.current_price}}</div>
                                <div :class="[item.rate < 0 ? 'colorr': 'colorg']">{{item.rate > 0 ? '+': ''}}{{item.rate}}%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mkbox">
                <div class="flexbox fle-sb">
                    <div class="boxtit">
                        <i class="el-icon-tickets fonts4"></i>
                        {{$t('index.sylb')}}
                    </div>
                </div>
                <div class="sylistbox">
                    <div class="tablet flexbox">
                        <div>{{$t('index.name')}}</div>
                        <div>{{$t('index.value')}}</div>
                        <div>{{$t('index.date')}}</div>
                    </div>
                    <div class="srollbox">
                        <vue-seamless-scroll :class-option="classOption" :data="incomeList" class="warp">
                            <div class="tablet itemvue flexbox" v-for="(item, index) in incomeList" :key="index">
                                <div>{{item.username}}</div>
                                <div>{{item.amount}}</div>
                                <div>{{item.createtime_text}}</div>
                            </div>
                        </vue-seamless-scroll>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {getHome} from '@/api/index'
    export default {
        name: 'HomeView',
        components: {},
        data() {
            return {
                classOption: {
                    step: 0.5
                },
                productList: [
                    {id: 0, name: '', price: '0.00', min_count: '0', rate: '0.0'},
                    {id: 0, name: '', price: '0.00', min_count: '0', rate: '0.0'},
                    {id: 0, name: '', price: '0.00', min_count: '0', rate: '0.0'}
                ],
                currencyList: [
                    {id: 0, name: '', current_price: '0.00', rate: '0.0'},
                    {id: 0, name: '', current_price: '0.00', rate: '0.0'},
                    {id: 0, name: '', current_price: '0.00', rate: '0.0'}
                ],
                incomeList: [],
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
        },
        mounted() {

        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                getHome().then(res => {
                    console.log(res)
                    const data = res.data
                    this.productList = data.productList
                    this.currencyList = data.currencyList
                    this.incomeList = data.incomeList

                }).catch(_ => {

                })
            },
            jumptolc() {
                this.$router.push({path: '/home/manageMoney'})
            },
            jumptolcdetail(id) {
                this.$router.push({path: '/home/detail/'+id})
            }
        }
    }
</script>
<style lang="scss" scoped>
    .contenbox {
        width: 1200px;
        margin: 0px auto;
        padding: 20px 0px;
        .fle-satr{
          justify-content: flex-start;
          &.margint{
            gap: 20px  160px;
          }
          &.margint2{
            gap:20px  120px ;
          }
        }
    }

    .sylistbox {
        .tablet {
            width: 100%;
            background: #3a3a3a;

            & > div {
                width: 33.2%;
                height: 50px;
                border: 1px solid #5c5c5c;
                line-height: 50px;
                font-size: 18px;

            }

            &.itemvue {
                border: 0px;
                background: #fff;

                & > div {
                    border: 0px;
                    color: #000;
                }

            }
        }

        .srollbox {
            height: 400px;
            background: #fff;
            overflow: hidden;
        }
    }

    .mkbox {
        color: #fff;
        padding: 20px 0px;

        .boxtit {
            color: rgb(255, 255, 255);
            font-size: 22px;
            text-align: left;
            font-weight: bolder;
            line-height: 60px;

            img {
                width: 40px;
                vertical-align: middle;

            }
        }

        .itembox {
            padding: 20px;
            // margin: 20px 0px;
            box-sizing: border-box;
            min-width: 290px;
            border-radius: 10px;
            background: rgb(36, 36, 36);
            color: #fff;
            line-height: 50px;
            font-size: 30px;
            text-align: left;
            &.hqitem{
              img{
                padding: 0px;
                padding-right: 6px;
              }
            }
            img {
                padding: 0px 20px 20px 0px;
                width: 100px;
                height: 100px;
            }

            &.hqitem {
                padding: 0px;
                overflow: hidden;
            }

            .titbar {
                -ms-flex-align: center;
                padding: 10px 20px;

                img {
                    width: 50px;
                    height: 50px;
                    // border-radius: 100%;
                    vertical-align: middle;
                }

                .fonwbig {
                    vertical-align: middle;
                }

            }

            .hqbox {
                background: #fff;
                padding: 20px;
                box-sizing: border-box;

                img {
                    padding-bottom: 0px;
                }
            }
        }

        .fonwbig {
            font-size: 40px;
            line-height: 60px;
        }
    }

    .bannerimg {
        width: 100%;
        height: 100%;

    }
</style>
